<template>
  <header
    id="navbar"
    class="sticky top-0 w-full bg-white/95 backdrop-blur-sm z-50 border-b border-neutral-200"
  >
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-16">
        <router-link to="/" class="flex items-center">
          <i class="fa fa-bolt text-primary text-2xl mr-2"></i>
          <span class="text-lg font-semibold">AI工具集市</span>
        </router-link>

        <!-- 搜索框 - 苹果风格 -->
        <div class="hidden md:flex relative w-1/3 max-w-md">
          <!-- <input
            type="text"
            placeholder="搜索AI工具..."
            class="w-full bg-neutral-100 rounded-md py-2 px-4 pl-10 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
          />
          <i
            class="fa fa-search absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400"
          ></i> -->
        </div>

        <!-- 导航链接和用户菜单 -->
        <div class="flex items-center space-x-6">
          <nav class="hidden md:flex items-center space-x-8">
            <router-link
              to="/"
              class="text-sm hover:text-primary apple-transition"
              active-class=""
              exact-active-class="text-primary font-bold"
              >首页</router-link
            >
            <router-link
              to="/explore"
              class="text-sm hover:text-primary apple-transition"
              active-class="text-primary font-bold"
              >探索工具</router-link
            >
            <router-link
              to="/categories"
              class="text-sm hover:text-primary apple-transition"
              active-class="text-primary font-bold"
              >分类</router-link
            >
            <router-link
              to="/subjects"
              class="text-sm hover:text-primary apple-transition"
              active-class="text-primary font-bold"
              >学科</router-link
            >
            <router-link
              to="/rankings"
              class="text-sm hover:text-primary apple-transition"
              active-class="text-primary font-bold"
              >排行榜</router-link
            >

            <router-link
            v-if="user.uid == '599e7eac72d6df6fd503c6101510b9ba'"
              to="/exam"
              class="text-sm hover:text-primary apple-transition"
              active-class="text-primary font-bold"
              >工具审核</router-link
            >
            <div
              @click="checkLogin('/submit')"
              id="desktop-publish-btn"
              class="text-sm hover:text-primary apple-transition cursor-pointer"
              :class="{ 'text-primary font-bold': $route.path === '/submit' }"
            >
              发布工具
            </div>
          </nav>

          <!-- 积分显示 -->
          <div
            class="hidden sm:flex items-center text-sm text-neutral-500"
            v-if="isLogin"
          >
            <i class="fa fa-star text-yellow-400 mr-1"></i>
            <span id="user-points">{{ user.points }}</span>
            <span class="ml-1">积分</span>
          </div>

          <!-- 用户菜单 - 根据登录状态动态显示 -->
          <div
            class="relative"
            id="user-menu-container"
            v-click-outside="closeDropdown"
          >
            <!-- 未登录状态 -->
            <div
              v-if="!isLogin"
              id="not-logged-in"
              class="flex items-center space-x-3"
            >
              <router-link
                to="/login"
                class="text-sm text-neutral-700 hover:text-primary apple-transition"
                >登录</router-link
              >
              <!-- <router-link
                to="/register"
                class="text-sm px-3 py-1 bg-primary text-white rounded-full hover:bg-primary/90 apple-transition"
                >注册</router-link
              > -->
            </div>

            <!-- 已登录状态 -->
            <div v-else class="relative">
              <button
                @click="toggleDropdown"
                class="flex items-center space-x-2 focus:outline-none"
              >
                <img
                  :src="user.avatar"
                  alt="User Avatar"
                  class="w-8 h-8 rounded-full border border-neutral-200 object-cover"
                />
                <span
                  class="text-sm font-medium text-neutral-700 hidden lg:block"
                  >{{ user.name }}</span
                >
                <i
                  class="fa fa-chevron-down text-xs text-neutral-400 transition-transform duration-200"
                  :class="{ 'rotate-180': isDropdownOpen }"
                ></i>
              </button>

              <!-- 下拉菜单 -->
              <div
                v-show="isDropdownOpen"
                class="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-lg border border-neutral-100 py-1 z-50 animate-fade-in-down origin-top-right"
              >
                <div class="px-4 py-3 border-b border-neutral-100">
                  <p class="text-sm font-medium text-neutral-900 truncate">
                    {{ user.username }}
                  </p>
                  <!-- <p class="text-xs text-neutral-500 truncate">
                    {{ state.user.email }}
                  </p> -->
                </div>
                <router-link
                  to="/user"
                  class="block px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50 hover:text-primary transition-colors"
                  @click="closeDropdown"
                >
                  <i class="fa fa-user-circle-o w-5"></i> 个人中心
                </router-link>
                <router-link
                  to="/submit"
                  class="block px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50 hover:text-primary transition-colors"
                  @click="closeDropdown"
                >
                  <i class="fa fa-plus-circle w-5"></i> 发布工具
                </router-link>
                <a
                  href="#"
                  class="block px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50 hover:text-primary transition-colors"
                >
                  <i class="fa fa-cog w-5"></i> 设置
                </a>
                <div class="border-t border-neutral-100 my-1"></div>
                <button
                  @click="logout"
                  class="block w-full text-left px-4 py-2 text-sm text-red-500 hover:bg-red-50 transition-colors"
                >
                  <i class="fa fa-sign-out w-5"></i> 退出登录
                </button>
              </div>
            </div>
          </div>

          <!-- 移动端菜单按钮 -->
          <button
            id="mobile-menu-toggle"
            class="md:hidden text-neutral-700 focus:outline-none"
          >
            <i class="fa fa-bars"></i>
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { ElMessageBox } from "element-plus";
export default {
  name: "nav-bar",
  data() {
    return {
      isDropdownOpen: false,
      points: 0,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isLogin() {
      return this.user && this.user.uid;
    },
  },
  watch: {
    // 监听登录状态变化，登录状态改变时重新查询积分
    isLogin(newVal) {
      if (newVal) {
        this.fetchUserPoints();
      }
    },
  },
  mounted() {
    // 组件挂载时，如果已登录则查询积分
    if (this.isLogin) {
      this.fetchUserPoints();
    }
  },
  methods: {
    checkLogin(router) {
      if (!this.isLogin) {
        ElMessageBox.confirm("需要使用当前功能，请先登录账号", "登录", {
          confirmButtonText: "登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/login");
          })
          .catch(() => {});
        return;
      }

      this.$axios({
        url: "aitool/user/checklogin",
      }).then((res) => {
        if (res.code == 200) {
          this.$router.push(router);
        }
      });
    },
    fetchUserPoints() {
      this.$axios({
        url: "user/integral",
      }).then((res) => {
        if (res.code == 200) {
          var points = res.data.point;
          this.$store.commit("setPoints", points);
        }
      });
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    closeDropdown() {
      this.isDropdownOpen = false;
    },
    logout() {
      this.closeDropdown();
      if (confirm("确定要退出登录吗？")) {
        localStorage.clear();
        this.$store.commit("clearUserInfo");
        this.$router.push("/");
      }
    },
  },
  directives: {
    clickOutside: {
      mounted(el, binding) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event, el);
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unmounted(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      },
    },
  },
};
</script>
